import PersonAddIcon from '@mui/icons-material/PersonAdd';
import { Tooltip, IconButton } from '@mui/material';
import React, { useContext } from 'react';

import RequestPermissionTooltip from '@/components/RequestPermissionTooltip';
import PermissionContext from '@/Contexts/Permissions';
import { PermissionActionEnum, PermissionEntityEnum } from '@/graphql/generated/graphql';

interface SubContractorRegisterToolbarType {
  onAddRecord: () => void;
}

const SubContractorRegisterToolbar: React.FC<SubContractorRegisterToolbarType> = ({ onAddRecord }) => {
  const { canPerformAction, checkRequestExists, requestPermission } = useContext(PermissionContext);
  const hasPermission = canPerformAction(PermissionActionEnum.Create, PermissionEntityEnum.Scheduling);

  return (
    <RequestPermissionTooltip
      hasPermission={hasPermission}
      requiredPermission={{
        action: PermissionActionEnum.Create,
        entity: PermissionEntityEnum.Scheduling,
      }}
      checkRequestExists={checkRequestExists}
      onRequest={requestPermission}
    >
      <Tooltip title={hasPermission ? 'Add Subcontractor' : ''}>
        <IconButton onClick={onAddRecord} size="small">
          <PersonAddIcon fontSize="small" />
        </IconButton>
      </Tooltip>
    </RequestPermissionTooltip>
  );
};

export default SubContractorRegisterToolbar;
